export enum InboundMessageType {
  Validate = 'validate',
  GetPublicData = 'getPublicData',
  Tokenize = 'tokenize',
  FocusInvalidField = 'focusInvalidField',
  ForceShowSavedCardCVV = 'forceShowSavedCardCVV',
  SetStyleAPIVariables = 'setStyleAPIVariables',
}
